import React, { useMemo } from 'react'
import { Group } from '@/model/types/goods'
import { getBEMCls } from '@/utils/classname'
import { selectGoodStore } from '../model'
import { observer } from 'mobx-react'

import './select-goods-group.scss'

interface SelectGoodsGroupItemProps {
    group: Group
    groupArr: Group[]
    groupIndex: number
    secondGroupId: number
    onClick: (v: Group[], groupIndex: number) => void
}

const SelectGoodsGroupItem: React.FC<SelectGoodsGroupItemProps> = observer(props => {
    const getCls = (e?: string, m?: string) => getBEMCls('select-goods-group', e, m)

    const { group } = props

    const isActive = useMemo(
        () =>
            group.id === selectGoodStore.activeId ||
            (!!group.secondary_group.length && group.secondary_group.every(i => i.id === selectGoodStore.secondId)),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [group, selectGoodStore.activeId, selectGoodStore.secondId],
    )

    return (
        <>
            <div
                className={`${
                    isActive
                        ? props.group.secondary_group.length
                            ? getCls('item', 'active-second')
                            : getCls('item', 'active')
                        : getCls('item')
                }`}
                onClick={() => {
                    props.onClick(props.groupArr, props.groupIndex)
                    if (!props.group.secondary_group.length) {
                        selectGoodStore.setActiveId(group.id)
                        selectGoodStore.setSecondId(0) // 初始化一下,防止在无二级分组的情况下请求二级分组
                    }
                }}
            >
                {!!group.secondary_group.length && !!group.secondary_group[0].id && (
                    <i
                        className={`icon6xiala2-20 iconfont ${getCls('arrow')}`}
                        style={{
                            transform: group.open ? 'rotate(0)' : 'rotate(-90deg)',
                        }}
                    />
                )}
                <div className={getCls('overflow')}>{group.name}</div>
            </div>
            <div
                className={getCls('item', 'menu')}
                style={{
                    height: group.open && group.secondary_group[0]?.id ? `${group.secondary_group.length * 70}px` : '0',
                }}
            >
                {!!group.secondary_group.length &&
                    group.secondary_group[0].id &&
                    group.secondary_group.map(second => (
                        <div
                            key={second.id}
                            className={`${
                                selectGoodStore.secondId === second.id ? getCls('menu', 'active') : getCls('menu')
                            }`}
                            onClick={() => {
                                selectGoodStore.setActiveId(group.id)
                                selectGoodStore.setSecondId(second.id)
                            }}
                        >
                            {second?.name}
                        </div>
                    ))}
            </div>
        </>
    )
})

export default SelectGoodsGroupItem
